import { CONFIG } from '../config'

let _backUrl = CONFIG.TENANT_PATH + 'login'
const UserApi = {
  /* 用户登录 */
  login (params) {
    return window.axios.get('/erp/api.user/login', {
      params
    })
  },
  wechatLogin () {
    return window.axios.get('/erp/api.wechat/wechat_login', {
      params: {
        back_url: _backUrl
      }
    })
  },
  loginByCode (params) {
    return window.axios.get('/erp/api.wechat/h5_login', {
      params
    })
  },
  getAuthUrl () {
    return window.axios.get('/erp/api.wechat/h5_auth_url', {
      params: {
        url: location.href
      }
    })
  },
  getUserInfo () {
    return window.axios.get('/erp/api.user/info')
  }

}
export default UserApi

